import React, { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { mdiAccountPlusOutline, mdiDownload } from "@mdi/js";
import commonUtils from "../../script/utils/commonUtils";

import userRest from "../../rest/userRest";

import { UserItem } from "./users/UserItem";
import { Table } from "../components/Table";
import { Spacer } from "../components/Spacer";
import { Search } from "../components/Search";
import { Button } from "../components/Button";
import { Layout } from "../containers/Layout";
import { ContentBody } from "../containers/ContentBody";
import { useSse } from "../hooks/useSse";
import { UserCreateDialog } from "./users/UserCreateDialog";
import { ContentHeader } from "../containers/ContentHeader";
import { ValidationProvider } from "../contexts/ValidationContext";

export const Users = () => {

    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [showUserCreateDialog, setShowUserCreateDialog] = useState(false);
    const [searchQuery, setSearchQuery] = useState(localStorage.getItem("userSearch") || "");

    useSse("UPDATE_USER", user => {
        const result = users.map(e => (e.id === user.id ? user : e));
        setUsers(result);
    });

    useSse("INSERT_USER", user => {
        const result = [...users];
        result.unshift(user);
        setUsers(result);
    });

    useEffect(() => {
        (async () => {
            const u = await userRest.getAll();
            setUsers(u);
        })();
    }, []);

    useEffect(() => {
        localStorage.setItem("userSearch", searchQuery);
        if (commonUtils.isBlank(searchQuery)) {
            setFilteredUsers(users);
            return;
        }
        const lowerQuery = searchQuery.toLowerCase();
        const result = users.filter(user =>
            user.username.toLowerCase().includes(lowerQuery) ||
            user.email.toLowerCase().includes(lowerQuery)
        );
        setFilteredUsers(result);
    }, [users, searchQuery]);

    const onDownloadUserStatsCsv = async () => {
        await userRest.downloadUserStatsCsv();
    };

    const onDownloadUserListCsv = async () => {
        await userRest.downloadUserListCsv();
    };

    return (
        <>
            <Layout>
                <ContentHeader title={intl.get("navigation.users")}>
                    <Button
                        simulateLoading
                        svgIcon={mdiDownload}
                        onClick={() => onDownloadUserStatsCsv()}
                        value={intl.get("users.downloadUserStatsCsv")} />
                    <Spacer variant="vertical" />
                    <Button
                        simulateLoading
                        svgIcon={mdiDownload}
                        onClick={() => onDownloadUserListCsv()}
                        value={intl.get("users.downloadUserListCsv")} />
                    <Spacer variant="vertical" />
                    <Button
                        svgIcon={mdiAccountPlusOutline}
                        value={intl.get("users.create")}
                        onClick={() => setShowUserCreateDialog(true)} />
                    <Spacer variant="vertical" />
                    <Search
                        id="antennaSearch"
                        value={searchQuery}
                        onChange={value => setSearchQuery(value)} />
                </ContentHeader>
                <ContentBody>
                    <Table>
                        <thead>
                            <tr>
                                <th width="10"></th>
                                <th width="100">{intl.get("users.username")}</th>
                                <th width="60">{intl.get("users.email")}</th>
                                <th width="60">{intl.get("users.createdAt")}</th>
                                <th width="60">{intl.get("users.active")}</th>
                                <th width="100">{intl.get("users.administrator")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers?.map(user =>
                                <UserItem key={user.id} user={user} />
                            )}
                        </tbody>
                    </Table>
                </ContentBody>
            </Layout>
            {showUserCreateDialog &&
                <ValidationProvider>
                    <UserCreateDialog onClose={() => setShowUserCreateDialog(false)} />
                </ValidationProvider>
            }
        </>
    );
};